
<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/vehicleManage/add')">新增</el-button>

      </template>
      <el-form :model="searchForm" ref="searchForm" inline class="global-form-label-width account-form"
        label-width="100px">

          <el-form-item prop="plateNumber" label="车牌号">
            <el-input v-model="searchForm.plateNumber" placeholder="请输入车牌号"></el-input>

          </el-form-item>
          <el-form-item prop="status" label="状态">
            <el-select v-model="searchForm.status" clearable filterable placeholder="请选择状态">
            <el-option v-for="(item, index) of resultArr" :value="item.value" :label="item.label"
              :key="index"></el-option>
          </el-select>
          </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="120" label="车牌号" prop="plateNumber"></el-table-column>
        <el-table-column min-width="120" label="司机姓名" prop="driver"></el-table-column>
        <el-table-column min-width="120" label="司机手机" prop="driverPhone"></el-table-column>

        <el-table-column min-width="120" label="状态" prop="status">
          <template v-slot="{ row }">
            <el-tag type="success" v-if="row.status == '1'">空闲</el-tag>
            <el-tag   v-if="row.status == '2'">工作中</el-tag>
            <el-tag type="warning" v-if="row.status == '3'">外出</el-tag>

          </template>
        </el-table-column>
        <el-table-column min-width="160" label="创建人姓名" prop="createUserName"></el-table-column>

        <el-table-column width="180" label="操作" fixed="right">
          <template v-slot="{ row }">

            <el-button type="text" @click="
              $router.push('/vehicleManage/detail?plateId=' + row.plateId)
              ">详情</el-button>
            <el-button type="text" v-if="hasEdit"
              @click="$router.push('/vehicleManage/edit?plateId=' + row.plateId)">编辑</el-button>

            <el-button v-if="hasDel" type="text" @click="deleteRow(row.plateId)" class="del-btn">删除</el-button>

          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>

  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'

export default {
  name: 'vehicleManage',
  mixins: [keepAlive],

  data () {
    return {
      tableData: [],

      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        status: '',
        plateNumber: ''

      },
      // 空闲/工作中/外出
      resultArr: [
        {
          label: '空闲',
          value: '1'
        },
        {
          label: '工作中',
          value: '2'
        },
        {
          label: '外出',
          value: '3'
        }

      ],
      specList: []

    }
  },
  computed: {
    buttonList () {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd () {
      return this.buttonList.includes('add')
    },
    hasEdit () {
      return this.buttonList.includes('edit')
    },
    hasDel () {
      return this.buttonList.includes('delete')
    }
  },
  created () {
    this.loadData()
  },

  methods: {

    deleteRow (plateId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.vehicleManage.deletePaVehicleInfo, {
          plateId
        }).then(() => {
          this.loadData()
        })
      })
    },

    loadData () {
      const params = {
        page: this.page,
        ...this.searchForm
      }
      console.log('params', params)
      this.$axios
        .get(this.$apis.vehicleManage.selectPaVehicleInfoByPage, {
          params: params
        })
        .then(res => {
          this.tableData = res.list
          this.total = res.total
        })
    },
    onSearch () {
      this.page = 1
      this.loadData()
    },
    onReset () {
      this.$refs.searchForm.resetFields()
    }

  }
}
</script>
<style lang="scss" scoped>

</style>
